module.exports = __webpack_public_path__ + "media/ejw/EJW_Logo_White-5c2d7b9d.png";